// extracted by mini-css-extract-plugin
module.exports = {"post_wrapper":"Post_post_wrapper__2Y15l","likes":"Post_likes__nws93","close_icon":"Post_close_icon__k2976"};